/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const AppNavEditableTitle = (props) => {
  const classStyle = classnames('cmp-appnaveditabletitle', {
    'has-underline': props.isEditable,
    'is-truncated': props.isTruncated,
  });

  return (
    <div className={classStyle} onClick={props.isEditable ? props.onClick : null}>
      {props.children}
    </div>
  );
};
AppNavEditableTitle.propTypes = {
  children: PropTypes.any,
  isEditable: PropTypes.bool,
  isTruncated: PropTypes.bool,
  onClick: PropTypes.func,
};

export default AppNavEditableTitle;
